import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '../lib/api';

interface ModuleStore {
  enabledModules: string[];
  setEnabledModules: (modules: string[]) => void;
  isEnabled: (slug: string) => boolean;
  refresh: () => Promise<void>;
}

export const useModuleStore = create<ModuleStore>()(
  persist(
    (set, get) => ({
      enabledModules: [],

      setEnabledModules: (modules) => set({ enabledModules: modules }),

      isEnabled: (slug) => get().enabledModules.includes(slug),

      refresh: async () => {
        const res = await api.get('/tenant/modules');
        const modules: { slug: string; is_enabled: boolean }[] = res.data.data ?? [];
        set({ enabledModules: modules.filter(m => m.is_enabled).map(m => m.slug) });
      },
    }),
    { name: 'usms-modules' }
  )
);
